import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const b64ToBytes = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

async function subscribe(cfg) {
  if (cfg.simulated) return { endpoint: `simulated:${crypto.randomUUID()}`, keys: {} };
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) throw new Error("Ce navigateur ne gère pas les notifications.");
  if ((await Notification.requestPermission()) !== "granted") throw new Error("Notifications refusées dans le navigateur.");
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(cfg.public_key) });
  return sub.toJSON();
}

export function PushCard() {
  const [cfg, setCfg] = useState(null);
  const load = () => api.get("/push/config").then(({ data }) => setCfg(data));
  useEffect(() => {
    load();
  }, []);
  if (!cfg) return null;
  const enable = async () => {
    try {
      const sub = await subscribe(cfg);
      await api.post("/push/subscribe", { endpoint: sub.endpoint, keys: sub.keys || {} });
      await api.post("/push/test");
      toast.success(cfg.simulated ? "Notifications activées (mode simulé : visible dans le journal dev)." : "Notifications activées.");
      load();
    } catch (e) {
      toast.error(e.message && !e.response ? e.message : errMsg(e));
    }
  };
  const disable = async () => {
    await api.post("/push/unsubscribe");
    toast.success("Notifications désactivées.");
    load();
  };
  return (
    <div className="mr-card p-4 flex items-center justify-between gap-3" data-testid="push-card">
      <div className="text-sm">
        <p className="font-medium">Notifications sur cet appareil</p>
        <p className="text-mr-muted" data-testid="push-status">{cfg.subscribed ? "Activées" : "Désactivées"}{cfg.simulated ? " · mode simulé" : ""}</p>
      </div>
      {cfg.subscribed
        ? <button data-testid="push-disable-button" className="mr-btn-secondary px-3" onClick={disable}><BellOff size={16} /> Désactiver</button>
        : <button data-testid="push-enable-button" className="mr-btn-primary px-3" onClick={enable}><Bell size={16} /> Activer</button>}
    </div>
  );
}
